var _desc, _defs, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1000,
    height: 1000,
    viewBox: "0 0 1000 1000",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 3.5.0")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    fill: "#ffffff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(18.9394 0 0 18.9394 500.0001 500.0001)",
    id: 96197
  }, /*#__PURE__*/React.createElement("g", {
    style: {},
    vectorEffect: "non-scaling-stroke"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 0.0003)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(96,26,74)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-24, -24.0003)",
    d: "M 47.2 42.6225 V 24.0001 C 47.1978 23.8763 47.1663 23.7549 47.108 23.6457 H 47.116 L 45.1576 19.7297 C 44.7544 18.9133 43.9217 18.3975 43.0112 18.4001 H 37.6 V 17.6001 C 37.6 17.3879 37.5156 17.1845 37.3656 17.0345 L 33.0344 12.7033 C 32.7465 12.4184 32.3904 12.2121 32 12.1041 V 6.70808 L 33.6 6.27848 V 8.21608 V 8.22168 C 33.5991 9.04319 34.0097 9.81057 34.6936 10.2657 C 34.9314 10.4243 35.2358 10.444 35.492 10.3174 C 35.7483 10.1908 35.9175 9.93705 35.936 9.6518 C 35.9545 9.36655 35.8194 9.09311 35.5816 8.93448 C 35.3429 8.77591 35.1996 8.50824 35.2 8.22168 V 8.21608 V 5.77848 C 35.76 5.45504 36.0702 4.8263 35.9862 4.1851 C 35.9022 3.5439 35.4404 3.01632 34.816 2.84808 L 24.4112 0.0544815 C 24.1418 -0.0175094 23.8582 -0.0175094 23.5888 0.0544815 L 13.184 2.84808 C 12.4843 3.03911 11.9989 3.67475 11.9989 4.40008 C 11.9989 5.12541 12.4843 5.76105 13.184 5.95208 L 16 6.70808 V 12.0001 H 15.9496 C 15.2384 12.0004 14.5641 12.317 14.1096 12.8641 L 10.5896 17.0881 C 10.4683 17.2312 10.4012 17.4125 10.4 17.6001 V 18.4001 H 4.9888 C 4.07898 18.3969 3.24652 18.9113 2.8424 19.7265 L 0.884 23.6425 H 0.892 C 0.833242 23.7526 0.801697 23.8752 0.8 24.0001 V 42.6225 C 0.306599 42.906 0.001716 43.431 0 44.0001 V 45.6001 C 0 46.4837 0.716344 47.2001 1.6 47.2001 H 12.2224 C 12.5059 47.6935 13.0309 47.9984 13.6 48.0001 H 34.4 C 34.9691 47.9984 35.4941 47.6935 35.7776 47.2001 H 46.4 C 47.2837 47.2001 48 46.4837 48 45.6001 V 44.0001 C 47.9983 43.431 47.6934 42.906 47.2 42.6225 Z M 35.2 42.4001 H 34.4 V 24.8001 H 45.6 V 42.4001 H 35.2 Z M 26.4 42.4001 H 21.6 V 33.6001 H 26.4 V 42.4001 Z M 27.2 32.0001 H 20.8 C 20.3582 32.0001 20 32.3583 20 32.8001 V 42.4001 H 15.2 V 24.8001 H 32.8 V 42.4001 H 28 V 32.8001 C 28 32.3583 27.6418 32.0001 27.2 32.0001 Z M 36 18.4001 V 20.0001 H 12 V 18.4001 H 36 Z M 34.4 21.6001 V 23.2001 H 13.6 V 21.6001 H 34.4 Z M 43.0112 20.0001 C 43.3145 19.9991 43.5919 20.1707 43.7264 20.4425 L 45.1056 23.2001 H 36 V 21.6001 C 36.8837 21.6001 37.6 20.8837 37.6 20.0001 H 43.0112 Z M 24 1.60008 L 34.4112 4.40008 H 34.4008 L 24.004 7.20008 L 13.6 4.39368 L 24 1.60008 Z M 17.6 7.13768 L 23.5888 8.74568 C 23.8581 8.8182 24.1419 8.8182 24.4112 8.74568 L 30.4 7.13768 V 12.0001 H 17.6 V 7.13768 Z M 15.3352 13.8881 C 15.4871 13.7057 15.7122 13.6002 15.9496 13.6001 H 31.3368 C 31.5492 13.5999 31.753 13.6842 31.9032 13.8345 L 34.8688 16.8001 H 12.908 L 15.3352 13.8881 Z M 4.2736 20.4425 C 4.40814 20.1707 4.68555 19.9991 4.9888 20.0001 H 10.4 C 10.4 20.8837 11.1163 21.6001 12 21.6001 V 23.2001 H 2.8944 L 4.2736 20.4425 Z M 1.6 44.0001 H 12 V 45.6001 H 1.6 V 44.0001 Z M 12.8 42.4001 H 2.4 V 24.8001 H 13.6 V 42.4001 H 12.8 Z M 13.6 46.4001 V 44.0001 H 34.4 V 46.4001 H 13.6 Z M 46.4 45.6001 H 36 V 44.0001 H 46.4 V 45.6001 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -2.4 4.0001)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(96,26,74)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-21.6, -28.0001)",
    d: "M 21.6 26.4001 C 21.1582 26.4001 20.8 26.7583 20.8 27.2001 V 28.8001 C 20.8 29.242 21.1582 29.6001 21.6 29.6001 C 22.0419 29.6001 22.4 29.242 22.4 28.8001 V 27.2001 C 22.4 26.7583 22.0419 26.4001 21.6 26.4001 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -13.5999 4.8)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(96,26,74)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-10.4001, -28.8)",
    d: "M 10.4001 27.2 C 9.95827 27.2 9.6001 27.5581 9.6001 28 V 29.6 C 9.6001 30.0418 9.95827 30.4 10.4001 30.4 C 10.8419 30.4 11.2001 30.0418 11.2001 29.6 V 28 C 11.2001 27.5581 10.8419 27.2 10.4001 27.2 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -18.4 4.8)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(96,26,74)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-5.6, -28.8)",
    d: "M 5.60005 27.2 C 5.15822 27.2 4.80005 27.5581 4.80005 28 V 29.6 C 4.80005 30.0418 5.15822 30.4 5.60005 30.4 C 6.04188 30.4 6.40005 30.0418 6.40005 29.6 V 28 C 6.40005 27.5581 6.04188 27.2 5.60005 27.2 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -13.5999 9.6)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(96,26,74)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-10.4001, -33.6)",
    d: "M 10.4001 32 C 9.95827 32 9.6001 32.3582 9.6001 32.8 V 34.4 C 9.6001 34.8418 9.95827 35.2 10.4001 35.2 C 10.8419 35.2 11.2001 34.8418 11.2001 34.4 V 32.8 C 11.2001 32.3582 10.8419 32 10.4001 32 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -18.4 9.6)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(96,26,74)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-5.6, -33.6)",
    d: "M 5.60005 32 C 5.15822 32 4.80005 32.3582 4.80005 32.8 V 34.4 C 4.80005 34.8418 5.15822 35.2 5.60005 35.2 C 6.04188 35.2 6.40005 34.8418 6.40005 34.4 V 32.8 C 6.40005 32.3582 6.04188 32 5.60005 32 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -13.5999 14.4)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(96,26,74)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-10.4001, -38.4)",
    d: "M 10.4001 36.8 C 9.95827 36.8 9.6001 37.1582 9.6001 37.6 V 39.2 C 9.6001 39.6419 9.95827 40 10.4001 40 C 10.8419 40 11.2001 39.6419 11.2001 39.2 V 37.6 C 11.2001 37.1582 10.8419 36.8 10.4001 36.8 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -18.4 14.4)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(96,26,74)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-5.6, -38.4)",
    d: "M 5.60005 36.8 C 5.15822 36.8 4.80005 37.1582 4.80005 37.6 V 39.2 C 4.80005 39.6419 5.15822 40 5.60005 40 C 6.04188 40 6.40005 39.6419 6.40005 39.2 V 37.6 C 6.40005 37.1582 6.04188 36.8 5.60005 36.8 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 18.4001 4.8)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(96,26,74)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-42.4001, -28.8)",
    d: "M 42.4001 27.2 C 41.9583 27.2 41.6001 27.5581 41.6001 28 V 29.6 C 41.6001 30.0418 41.9583 30.4 42.4001 30.4 C 42.8419 30.4 43.2001 30.0418 43.2001 29.6 V 28 C 43.2001 27.5581 42.8419 27.2 42.4001 27.2 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 13.6 4.8)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(96,26,74)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-37.6, -28.8)",
    d: "M 37.6 27.2 C 37.1582 27.2 36.8 27.5581 36.8 28 V 29.6 C 36.8 30.0418 37.1582 30.4 37.6 30.4 C 38.0419 30.4 38.4 30.0418 38.4 29.6 V 28 C 38.4 27.5581 38.0419 27.2 37.6 27.2 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 18.4001 9.6)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(96,26,74)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-42.4001, -33.6)",
    d: "M 42.4001 32 C 41.9583 32 41.6001 32.3582 41.6001 32.8 V 34.4 C 41.6001 34.8418 41.9583 35.2 42.4001 35.2 C 42.8419 35.2 43.2001 34.8418 43.2001 34.4 V 32.8 C 43.2001 32.3582 42.8419 32 42.4001 32 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 13.6 9.6)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(96,26,74)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-37.6, -33.6)",
    d: "M 37.6 32 C 37.1582 32 36.8 32.3582 36.8 32.8 V 34.4 C 36.8 34.8418 37.1582 35.2 37.6 35.2 C 38.0419 35.2 38.4 34.8418 38.4 34.4 V 32.8 C 38.4 32.3582 38.0419 32 37.6 32 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 18.4001 14.4)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(96,26,74)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-42.4001, -38.4)",
    d: "M 42.4001 36.8 C 41.9583 36.8 41.6001 37.1582 41.6001 37.6 V 39.2 C 41.6001 39.6419 41.9583 40 42.4001 40 C 42.8419 40 43.2001 39.6419 43.2001 39.2 V 37.6 C 43.2001 37.1582 42.8419 36.8 42.4001 36.8 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 13.6 14.4)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(96,26,74)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-37.6, -38.4)",
    d: "M 37.6 36.8 C 37.1582 36.8 36.8 37.1582 36.8 37.6 V 39.2 C 36.8 39.6419 37.1582 40 37.6 40 C 38.0419 40 38.4 39.6419 38.4 39.2 V 37.6 C 38.4 37.1582 38.0419 36.8 37.6 36.8 Z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 2.4001 4.0001)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(96,26,74)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " translate(-26.4001, -28.0001)",
    d: "M 26.4001 26.4001 C 25.9583 26.4001 25.6001 26.7583 25.6001 27.2001 V 28.8001 C 25.6001 29.242 25.9583 29.6001 26.4001 29.6001 C 26.8419 29.6001 27.2001 29.242 27.2001 28.8001 V 27.2001 C 27.2001 26.7583 26.8419 26.4001 26.4001 26.4001 Z",
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.052b52ac55ce077ab53b240f8860c202.svg";
export { ForwardRef as ReactComponent };